import { useEffect, useState } from "react";
import sortBy from "lodash.sortby";
import {
  Row,
  Container,
  Col,
  Table,
  Button,
  Popover,
  OverlayTrigger,
  Form,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import SatAPI from "../../_services/sat";
import toastService from "../../_services/toastService";
import { useRef } from "react";
import generatePDF, { Margin } from "react-to-pdf";

const api = SatAPI();

function PerformanceScheme() {
  const snapshot = useSelector((state) => state.snapshot.fileName);
  const [collega, setCollega] = useState([]);
  const [olaAssignments, setOlaAssignments] = useState([]);
  const [taskAssignments, setTaskAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [isSATUser, setIsSATUser] = useState(false);
  const [collegas, setCollegas] = useState([]);
  const [collegaID, setCollegaID] = useState(-1);
  const [globalSettings, setGlobalSettings] = useState([]);
  const pdfTargetRef = useRef();

  const pdfOptions = {
    filename:
      "PR " +
      collega.firstName +
      " " +
      collega.lastName +
      " - " +
      globalSettings.academicYear +
      ".pdf",
    // default is `save`
    method: "save",
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    resolution: 3,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.MEDIUM,
      // default is 'A4'
      format: "A3",
      // default is 'portrait'
      orientation: "portrait",
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break,
    // so use with caution.
    overrides: {
      // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
      pdf: {
        compress: true,
      },
      // see https://html2canvas.hertzen.com/configuration for more options
      canvas: {
        useCORS: true,
      },
    },
  };

  const loadPerformanceScheme = async () => {
    try {
      setLoading(true);

      const shownOlas = [];
      let coveredCollegas = [];

      console.log(snapshot);
      const settings = await api.getGlobalSettings(snapshot);
      setGlobalSettings(settings);
      const response = await api.getMyself(snapshot);
      let assignmentsFromAPI = await api.getAssignmentsByCollegaId(
        response.ID,
        snapshot
      );
      assignmentsFromAPI = assignmentsFromAPI.sort(
        (a, b) => a.ola.semester > b.ola.semester
      );
      const taskAssignmentsFromAPI = await api.getTaskAssignmentsByCollegaId(
        response.ID,
        snapshot
      );
      console.log("My assignments:", assignmentsFromAPI);
      console.log("My task assignments:", taskAssignmentsFromAPI);

      assignmentsFromAPI
        .filter((b) => b.collegaID === response.ID)
        .forEach((a) => {
          coveredCollegas = [];

          a.numberOfGroups = assignmentsFromAPI.filter(
            (b) => b.collegaID === response.ID && b.ola.ID === a.ola.ID
          ).length;
          a.isOpoCoordinator =
            assignmentsFromAPI.filter(
              (b) =>
                b.collegaID === response.ID &&
                b.ola.ID === a.ola.ID &&
                b.opoResponsible === true
            ).length > 0;

          if (a.ola.assignments) {
            const opoRespAssignment = a.ola.assignments.filter(
              (o) => o.opoResponsible
            );
            if (opoRespAssignment.length > 0) {
              a.ola.assignments = sortBy(a.ola.assignments, [
                (o) => !o.opoResponsible,
                (o) => o.collegaID !== opoRespAssignment[0].collegaID,
                "collega.lastName",
                "collega.firstName",
              ]);
            } else {
              a.ola.assignments = sortBy(a.ola.assignments, [
                "collega.lastName",
                "collega.firstName",
              ]);
            }
          }

          console.log(a.ola);
          if (a.ola.assignments) {
            a.ola.assignments.forEach((ca) => {
              ca.numberOfAssignments = a.ola.assignments.filter(
                (b) => b.collegaID === ca.collegaID
              ).length;

              if (coveredCollegas.indexOf(ca.collegaID) > -1) {
                ca.show = false;
              } else {
                ca.show = true;
                coveredCollegas.push(ca.collegaID);
              }
            });
          }

          console.log("Collega assignments:", a.collegaAssignments);
          if (shownOlas.indexOf(a.ola.ID) > -1) {
            a.show = false;
          } else {
            a.show = true;

            shownOlas.push(a.ola.ID);
          }
        });
      taskAssignmentsFromAPI
        .filter((b) => b.collegaID === response.ID)
        .forEach((a) => {
          a.show = true;
        });

      setOlaAssignments(assignmentsFromAPI);
      setTaskAssignments(taskAssignmentsFromAPI);
      setCollega(response);

      // And now I wanne be...
      if (localStorage.getItem("isSATUser") === "true") {
        setIsSATUser(true);
        const allCollegas = await api.getCollegas(snapshot);
        if (localStorage.getItem("SAT-typeSorting") === "firstname") {
          allCollegas.sort(
            (a, b) =>
              a.firstName.localeCompare(b.firstName) ||
              a.lastName.localeCompare(b.lastName)
          );
        } else {
          allCollegas.sort(
            (a, b) =>
              a.lastName.localeCompare(b.lastName) ||
              a.firstName.localeCompare(b.firstName)
          );
        }
        setCollegas(allCollegas);
      }

      setLoading(false);
      return response;
    } catch (error) {
      console.log(error);
      toastService.send({ title: "An error occured", message: error });
    }
    return [];
  };

  const changeCollegaID = async (changedCollegaID) => {
    setLoading(true);

    const shownOlas = [];
    let coveredCollegas = [];

    if (changedCollegaID > -1) {
      console.log(snapshot);
      const newResponse = await api.getCollegaWithContactHoursById(
        changedCollegaID,
        snapshot
      );
      let newAssignmentsFromAPI = await api.getAssignmentsByCollegaId(
        newResponse.ID,
        snapshot
      );
      newAssignmentsFromAPI = newAssignmentsFromAPI.sort(
        (a, b) => a.ola.semester > b.ola.semester
      );
      const newTaskAssignmentsFromAPI = await api.getTaskAssignmentsByCollegaId(
        newResponse.ID,
        snapshot
      );
      console.log("My assignments:", newAssignmentsFromAPI);
      console.log("My task assignments:", newTaskAssignmentsFromAPI);

      newAssignmentsFromAPI
        .filter((b) => b.collegaID === changedCollegaID)
        .forEach((a) => {
          coveredCollegas = [];

          a.numberOfGroups = newAssignmentsFromAPI.filter(
            (b) => b.collegaID === newResponse.ID && b.ola.ID === a.ola.ID
          ).length;
          a.isOpoCoordinator =
            newAssignmentsFromAPI.filter(
              (b) =>
                b.collegaID === newResponse.ID &&
                b.ola.ID === a.ola.ID &&
                b.opoResponsible === true
            ).length > 0;

          if (a.ola.assignments) {
            const opoRespAssignment = a.ola.assignments.filter(
              (o) => o.opoResponsible
            );
            if (opoRespAssignment.length > 0) {
              a.ola.assignments = sortBy(a.ola.assignments, [
                (o) => !o.opoResponsible,
                (o) => o.collegaID !== opoRespAssignment[0].collegaID,
                "collega.lastName",
                "collega.firstName",
              ]);
            } else {
              a.ola.assignments = sortBy(a.ola.assignments, [
                "collega.lastName",
                "collega.firstName",
              ]);
            }
          }

          console.log(a.ola);
          if (a.ola.assignments) {
            a.ola.assignments.forEach((ca) => {
              ca.numberOfAssignments = a.ola.assignments.filter(
                (b) => b.collegaID === ca.collegaID
              ).length;

              if (coveredCollegas.indexOf(ca.collegaID) > -1) {
                ca.show = false;
              } else {
                ca.show = true;
                coveredCollegas.push(ca.collegaID);
              }
            });
          }

          console.log("Collega assignments:", a.collegaAssignments);
          if (shownOlas.indexOf(a.ola.ID) > -1) {
            a.show = false;
          } else {
            a.show = true;

            shownOlas.push(a.ola.ID);
          }
        });

      newTaskAssignmentsFromAPI
        .filter((b) => b.collegaID === newResponse.ID)
        .forEach((a) => {
          a.show = true;
        });

      setOlaAssignments(newAssignmentsFromAPI);
      setTaskAssignments(newTaskAssignmentsFromAPI);
      setCollega(newResponse);
      setCollegaID(changedCollegaID);
    }

    setCollegaID(changedCollegaID);
    setLoading(false);
  };

  useEffect(() => {
    loadPerformanceScheme();
  }, [snapshot]);

  const popover = () => (
    <Popover>
      <Popover.Header as="h3">Legende</Popover.Header>
      <Popover.Body>
        <h5>Symbolen</h5>
        <p>
          <i className="far fa-award" /> OPO-coördinator
        </p>
        <p>
          <i className="far fa-user-friends" /> Pair teaching
        </p>
      </Popover.Body>
    </Popover>
  );

  const downloadPdf = async (target, options) => {
    setLoadingPDF(true);
    await generatePDF(target, options);
    setLoadingPDF(false);
  };

  if (loading) {
    return (
      <div className="text-center">
        <i className="fad fa-spinner-third fa-spin fa-5x" />
      </div>
    );
  }
  return (
    <Container>
      <Row className="mb-3">
        <Col className="text-end">
          <Button
            disabled={loadingPDF}
            variant="adobepdf"
            onClick={() => downloadPdf(pdfTargetRef, pdfOptions)}
          >
            {loadingPDF && <i className="far fa-spinner fa-pulse" />}
            {!loadingPDF && <i className="far fa-file-pdf" />}
            &nbsp;Download als PDF
          </Button>
        </Col>
      </Row>

      <div ref={pdfTargetRef}>
        <Row>
          <Col>
            <h1>
              Prestatieregeling academiejaar {globalSettings.academicYear}
            </h1>
            <p>
              <span className="font-bold">Naam:</span> {collega.firstName}{" "}
              {collega.lastName} ({collega.uNumber})
            </p>
          </Col>
        </Row>
        {isSATUser && (
          <Row>
            <Form.Group className="mb-3">
              <Form.Select
                onChange={(e) => changeCollegaID(parseInt(e.target.value, 10))}
                value={collegaID}
              >
                <option value={-1}>Andere collega bekijken</option>
                {collegas.map((c) => (
                  <option key={c.ID} value={c.ID}>
                    {c.firstName} {c.lastName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Row>
        )}
        <Row className="my-2">
          <Col>
            <div className="float-end fixedElement">
              <OverlayTrigger
                trigger="click"
                placement="left"
                overlay={popover()}
              >
                <Button variant="info" className="me-2">
                  <i className="fas fa-question" />
                </Button>
              </OverlayTrigger>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              <Col>
                <h3>
                  Onderwijsopdrachten (Teach):{" "}
                  {olaAssignments
                    .filter((x) => x.show)
                    .reduce(
                      (n, { ola }) =>
                        n +
                        Math.round(
                          ola.assignments
                            .filter((x) => x.collegaID == collega.ID)
                            .reduce((n, { vte }) => n + vte, 0) * 2
                        ) / 2,
                      0
                    )}{" "}
                  %
                </h3>
              </Col>
              <Col md={3}>
                <Table striped bordered hover className="text-center">
                  <thead>
                    <tr>
                      <th>Q1</th>
                      <th>Q2</th>
                      <th>Q3</th>
                      <th>Q4</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {olaAssignments.filter(x => x.show)
                          .reduce(
                            (n, { contactHours }) =>
                              n + contactHours.contactHoursQ1, 0)
                        }
                      </td>
                      <td>{olaAssignments.filter(x => x.show)
                        .reduce(
                          (n, { contactHours }) =>
                            n + contactHours.contactHoursQ2, 0)}</td>
                      <td>{olaAssignments.filter(x => x.show)
                        .reduce(
                          (n, { contactHours }) =>
                            n + contactHours.contactHoursQ3, 0)}</td>
                      <td>{olaAssignments.filter(x => x.show)
                        .reduce(
                          (n, { contactHours }) =>
                            n + contactHours.contactHoursQ4, 0)}</td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Naam</th>
                  <th>Opleiding</th>
                  <th>Lesgroepen</th>
                  <th>Contacturen</th>
                  <th className="assigncol">Vakdocenten</th>
                </tr>
              </thead>
              <tbody>
                {olaAssignments.map((c) => (
                  <tr key={c.ID} className={c.show ? "" : "d-none"}>
                    <td>
                      {c.ola.name}
                      <br />
                      <i className="fas fa-arrow-right" />
                      &nbsp;
                      {Math.round(
                        c.ola.assignments
                          .filter((x) => x.collegaID == collega.ID)
                          .reduce((n, { vte }) => n + vte, 0) * 2
                      ) / 2}
                      &nbsp;%
                      <br />
                      <br />
                      {c.ola.teachersPerClass > 1 && (
                        <span>
                          <i className="far fa-user-friends" /> Pair teaching
                        </span>
                      )}
                      <br />
                      {c.isOpoCoordinator && (
                        <span>
                          <i className="far fa-award" /> OPO-coördinator
                        </span>
                      )}
                    </td>
                    <td className="text-center">
                      {c.ola.phases[0].phase.programme.name}
                    </td>
                    <td className="text-center">
                      {c.ola.internship ? (
                        <span>{c.internshipStudents} studenten</span>
                      ) : (
                        <span>{c.numberOfGroups}</span>
                      )}
                    </td>
                    <td>
                      {!c.ola.internship && (
                        <Table striped bordered hover className="text-center">
                          <thead>
                            <tr>
                              <th>Q1</th>
                              <th>Q2</th>
                              <th>Q3</th>
                              <th>Q4</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{c.contactHours.contactHoursQ1}</td>
                              <td>{c.contactHours.contactHoursQ2}</td>
                              <td>{c.contactHours.contactHoursQ3}</td>
                              <td>{c.contactHours.contactHoursQ4}</td>
                            </tr>
                          </tbody>
                        </Table>
                      )}
                    </td>
                    <td>
                      {!c.ola.internship && (
                        <Row className="mx-2">
                          {c.ola.assignments.map((z) => (
                            <Col xs={2} className="my-2 px-1">
                              <Button
                                variant="outline-dark"
                                className={"collegaButton"}
                              >
                                <div className="collega-name text-truncate">
                                  {z.opoResponsible && (
                                    <span>
                                      <i className="far fa-award" />{" "}
                                    </span>
                                  )}{" "}
                                  {localStorage.getItem("SAT-typeName") ===
                                    "volledig"
                                    ? z.collega.firstName
                                    : z.collega.initials}
                                </div>

                                {localStorage.getItem("SAT-typeName") ===
                                  "volledig" && (
                                    <div className="collega-name text-truncate">
                                      {z.collega.lastName}
                                    </div>
                                  )}

                                <div className="fw-bold assignmentVTE">
                                  {c.ola.planPerPhase && (
                                    <span className="font-bold">
                                      {c.ola.phases.find(phase => phase.phaseID === z.phase?.ID).teachersPerClassOverride > 1 && (
                                        <span>
                                          <i className="far fa-user-friends" />{" "}
                                        </span>
                                      )}
                                      {z.phase?.name}
                                    </span>
                                  )}
                                </div>

                              </Button>
                            </Col>
                          ))}
                        </Row>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <h3>
              Deeltaken: {taskAssignments.reduce((n, { vte }) => n + vte, 0)} %
            </h3>
            <Table bordered hover>
              <thead>
                <tr>
                  <th>Naam</th>
                  <th>Pilaar</th>
                  <th>Opleiding</th>
                  <th>Percentage</th>
                </tr>
              </thead>
              <tbody>
                {taskAssignments.map((assignment) => (
                  <tr
                    key={assignment.ID}
                    className={assignment.show ? "" : "d-none"}
                  >
                    <td>{assignment.task.name}</td>
                    <td>
                      {assignment.task.labels
                        .map((label) => label.name)
                        .join(", ")}
                    </td>
                    <td>{assignment.programme.name}</td>
                    <td>
                      <span>{assignment.vte} %</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <h3>Forfait: {
              Math.round((taskAssignments.reduce((n, { forfait }) => n + forfait, 0) + olaAssignments
                .filter((x) => x.show)
                .reduce(
                  (n, { ola }) =>
                    n +
                    parseFloat(
                      ola.assignments
                        .filter((x) => x.collegaID == collega.ID)
                        .reduce((n, { forfait }) => n + forfait, 0)
                    ),
                  0
                )) * 2) / 2

            } %</h3>
            <h2>Totaal: {
              olaAssignments
                .filter((x) => x.show)
                .reduce(
                  (n, { ola }) =>
                    n +
                    Math.round(
                      ola.assignments
                        .filter((x) => x.collegaID == collega.ID)
                        .reduce((n, { vte }) => n + vte, 0) * 2
                    ) / 2,
                  0
                )
              +
              taskAssignments.reduce((n, { vte }) => n + vte, 0)
              +
              Math.round(
                (taskAssignments.reduce((n, { forfait }) => n + forfait, 0) + olaAssignments
                  .filter((x) => x.show)
                  .reduce(
                    (n, { ola }) =>
                      n +
                      parseFloat(
                        ola.assignments
                          .filter((x) => x.collegaID == collega.ID)
                          .reduce((n, { forfait }) => n + forfait, 0)
                      ),
                    0
                  )) * 2) / 2
            } %</h2>

          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default PerformanceScheme;
